import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-h1",
  "use": "format-h1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-h1\"><path fill-rule=\"evenodd\" d=\"M3 5h2v6h5V5h2v14h-2v-6H5v6H3V5Zm14 12V7h-2c0-.92 1.024-2 2-2h2v12h2v2h-6v-2h2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol